import type { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';

const ORG_SCOPED_PATH = /^\/orgs\//;

/**
 * 공유 단체 설정 화면(`orgSettingsRoutes()`)이 쓰는 spinoff-platform 생성 클라이언트는 상대 경로
 * (`/orgs/:orgId/...`)로 요청한다 — 이 앱의 API는 별도 오리진(`environment.apiUrl`)이라 그 경로에만
 * 오리진을 붙인다. 이 앱 자신의 `ApiService`는 처음부터 절대 URL을 만들어 쓰므로 영향이 없다.
 *
 * `spinoffAuthInterceptor`보다 **앞에** 둔다 — 그 인터셉터는 `config.apiBaseUrl`로 시작하는 요청에만
 * 토큰을 붙이므로, 오리진이 먼저 붙어 있어야 org 토큰이 실린다. `/orgs/`로만 한정하는 이유는
 * member-picker처럼 무인증이어야 하는 상대 경로가 같은 방식으로 오리진이 붙어 토큰을 받는 것을
 * 막기 위해서다(app.config.ts의 인터셉터 순서 주석 참고).
 */
export const orgApiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!ORG_SCOPED_PATH.test(req.url)) return next(req);
  const base = environment.apiUrl.endsWith('/') ? environment.apiUrl.slice(0, -1) : environment.apiUrl;
  return next(req.clone({ url: `${base}${req.url}` }));
};
